import Vue from 'vue';
import Vuex from 'vuex';

// Login
import login from './modules/login/login';
// Sa
import sa_sign_up from './modules/sa/sign-up';
import sa_qr_code from './modules/sa/qr-code';
import sa_profile from './modules/sa/profile';
import sa_contacts from './modules/sa/contacts';
import sa_label from './modules/sa/label';
import sa_reservation from './modules/sa/reservation';
import sa_my_customer from './modules/sa/my-customer';
import sa_msg_manager from './modules/sa/msg-manager';
import sa_chat from './modules/sa/chat';
import sa_temp from './modules/sa/temp';
import sa_group_push from './modules/sa/group_push';
import sa_member_search from './modules/sa/member-search';
import sa_reports from './modules/sa/reports';
import sa_invitation from './modules/sa/invitation';
import sa_product_buy from './modules/sa/product_buy';
import sa_product_fit from './modules/sa/product_fit';
import sa_line_point from './modules/sa/line_point';
import sa_stores_manager from './modules/sa/stores-manager';
import sa_order_online from './modules/sa/order-online';
import sa_inform_list from './modules/sa/inform-list';
import sa_item_list from './modules/sa/item_list';
import sa_points_card from './modules/sa/points-card';

// Member
import member_sign_up from './modules/member/sign-up';
import member_bind_sa from './modules/member/bind-sa';
import member_change_sa from './modules/member/change-sa';
import member_my_sa from './modules/member/my-sa';
import member_reservation from './modules/member/reservation';
import member_invitation from './modules/member/invitation';

// Sm
import sm_stores_manager from './modules/sm/stores-manager';

// Sic
// Sa
import sic_qr_code from './modules/sic/qr-code';
import sic_profile from './modules/sic/profile';
import sic_label from './modules/sic/label';
import sic_reservation from './modules/sic/reservation';
import sic_my_customer from './modules/sic/my-customer';
import sic_msg_manager from './modules/sic/msg-manager';
import sic_member_search from './modules/sic/member-search';
import sic_reports from './modules/sic/reports';
import sic_district_reports from './modules/sic/district-reports';
import sic_invitation from './modules/sic/invitation';
import sic_stores_manager from './modules/sic/stores-manager';
import sic_by_ba_reports from './modules/sic/by-ba-reports';
import sic_by_counter_reports from './modules/sic/by-counter-reports';
Vue.use(Vuex);

const store = new Vuex.Store({
  // 嚴格模式，禁止直接修改 state，深度監測狀態樹來檢測不合規的狀態變更
  // 發布模式必須關閉避免性能損失
  strict: process.env.NODE_ENV !== 'production',
  state: {
    // 全域 Loading
    isLoading: true
  },
  mutations: {
    toggleLoading(state, Boolean) {
      state.isLoading = Boolean;
    }
  },
  modules: {
    // Login
    login,
    // Sa
    sa_sign_up,
    sa_qr_code,
    sa_profile,
    sa_contacts,
    sa_label,
    sa_reservation,
    sa_my_customer,
    sa_msg_manager,
    sa_chat,
    sa_temp,
    sa_group_push,
    sa_member_search,
    sa_reports,
    sa_invitation,
    sa_product_buy,
    sa_line_point,
    sa_product_fit,
    sa_stores_manager,
    sa_order_online,
    sa_inform_list,
    sa_item_list,
    sa_points_card,
    // Member
    member_sign_up,
    member_bind_sa,
    member_change_sa,
    member_my_sa,
    member_reservation,
    member_invitation,
    // Sm
    sm_stores_manager,
    // Sic
    sic_qr_code,
    sic_profile,
    sic_label,
    sic_reservation,
    sic_my_customer,
    sic_msg_manager,
    sic_member_search,
    sic_reports,
    sic_district_reports,
    sic_invitation,
    sic_stores_manager,
    sic_by_ba_reports,
    sic_by_counter_reports,
  }
});

export default store;
